const SvgAdd3 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 18 18">
    <path fill="#373737" fillRule="evenodd" d="M18 8.5H0v1h18z" clipRule="evenodd" />
    <path fill="#373737" fillRule="evenodd" d="M9.5 18V0h-1v18z" clipRule="evenodd" />
  </svg>;
export default SvgAdd3;